import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import CharacterMakerActorGroup from '../../../domain/entities/CharacterMakerActorGroup';

export default function reducer(
  state: {[key: number]: CharacterMakerActorGroup} = {},
  action: AnyAction,
): {[key: number]: CharacterMakerActorGroup} {
  switch (action.type) {
    case Types.IndexCharacterMakerActorGroupsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: CharacterMakerActorGroup},
            record: CharacterMakerActorGroup,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowCharacterMakerActorGroupSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
